import React from 'react';
import { IndexRoute, Route } from 'react-router';
import Managers from './managers';

export default (
  <Route path="gestores">
    <IndexRoute component={props => <Managers {...props} />} />
  </Route>
);
